import { GTMProvider as Provider } from '@elgorditosalsero/react-gtm-hook';

import config from 'config';

export const GTMProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => {
  const gtmParams = { id: config.app.gtm };

  return <Provider state={gtmParams}>{children}</Provider>;
};
